import { SelectFormField, TextFormField } from 'components/Forms/FormFields';
import { useFormContext } from 'contexts/formContext';
import { CurrentValuesSelected } from '../CurrentValuesSelected/CurrentValuesSelected';
import { FilterStyleBase } from '../MethodsForFilters/FilterStyleBase';
import { ActionSubmitSearch } from 'components/Actions/ActionSubmitSearch';

function WalletFiltersForm() {
    const { watch } = useFormContext();

    return (
        <>
            <SelectFormField
                name="optionFilter"
                label="Filtrar por"
                variant="outlined"
                fullWidth
                options={[
                    { label: 'Todos', value: 'searchString' },
                    { label: 'Código convênio', value: 'walletsCode' },
                    { label: 'Nome ', value: 'name' },
                    { label: 'Conta ', value: 'bankAccount' },
                ]}
            />
            {watch('optionFilter') === 'searchString' && (
               <TextFormField
                    name="searchString"
                    variant="outlined"
                    label="Filtrar por todos"
                    fullWidth
                    InputProps={{
                        endAdornment:<ActionSubmitSearch/>,
                    }}
                />
            )}
            {watch('optionFilter') === 'name' && (
                <TextFormField
                    name="name"
                    variant="outlined"
                    label="Filtrar por nome"
                    fullWidth
                    InputProps={{
                        endAdornment:<ActionSubmitSearch/>,
                    }}
                />
            )}
            {watch('optionFilter') === 'walletsCode' && (
                <TextFormField
                    name="walletsCode"
                    variant="outlined"
                    label="Filtrar por código convênio"
                    fullWidth
                    InputProps={{
                        endAdornment: <ActionSubmitSearch/>,
                    }}
                />
            )}
            {watch('optionFilter') === 'bankAccount' && (
                <TextFormField
                    name="bankAccount"
                    variant="outlined"
                    label="Filtrar por conta"
                    fullWidth
                    InputProps={{
                        endAdornment: <ActionSubmitSearch/>,
                    }}
                />
            )}
        </>
    );
}

type WalletFiltersProps = {
    currentValues: any;
    removeFilterSelected: (index: number) => void;
};

export const WalletFilters = ({ currentValues, removeFilterSelected }: WalletFiltersProps) => {
    return (
        <FilterStyleBase
            formFilters={<WalletFiltersForm />}
            currentValues={
                <CurrentValuesSelected
                    currentValues={currentValues}
                    removeFilterSelected={removeFilterSelected}
                />
            }
        />
    );
};
